<template>
  <div class="px-4">
    <Link
      :href="route('settings')"
      v-if="$page.props.user && $page.props.user.roles.find(r => r.name == 'Super Admin')"
      class="inline-flex items-center justify-center p-2 bg-white text-gray-700 hover:text-white hover:bg-blue-700 rounded font-bold"
    >
      <icons name="cog"></icons>
    </Link>
    <!-- <button
      @click="alerts = true"
      class="inline-flex items-center justify-center p-2 bg-white text-gray-700 hover:text-white hover:bg-blue-700 rounded font-bold focus:outline-none"
    >
      <icons name="bell"></icons>
    </button>
    <alerts-modal :show="alerts" @close="alerts = false" /> -->
    <!-- <a
      href="#"
      class="inline-flex items-center justify-center p-2 bg-white text-gray-700 hover:text-white hover:bg-blue-700 rounded font-bold"
    >
      <icons name="plus"></icons>
    </a> -->
    <!-- <a
      href="#"
      class="inline-flex items-center justify-center p-2 bg-white text-gray-700 hover:text-white hover:bg-blue-700 rounded font-bold"
    >
      <icons name="menu"></icons>
    </a> -->
  </div>
</template>

<script>
import AlertsModal from './AlertsModal';
import { Link } from '@inertiajs/inertia-vue3';

export default {
  components: { AlertsModal, Link },
  data() {
    return { alerts: false };
  },
};
</script>
